import React from 'react';
import Component from '../../components/Component';
import config from '../../config';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';

export default class Infobox extends Component {

	constructor(props, context) {
		super(props);
		this.state = {
			data: null
		}
	}

	componentDidMount() {
		this.load();
	}

    componentWillReceiveProps(nextProps) {
		if (nextProps.id != this.props.id) {
			this.load(nextProps.id);
		}
    }

    load(id = this.props.id) {
		if (id) {
            config.getApiClient.call('vehicle.fetch', {id}).then((data) => {
                this.setState({data: data.form});
            });
        }
        else {
            this.setState({data: null});
		}
	}

	render() {

		if (!this.state.data) {
			return <div>
                <fieldset><legend>Vozík</legend></fieldset>
			</div>
		}

		return (
			<div>
                <fieldset><legend>Vozík</legend></fieldset>
                <table className="form" style={{width:'100%'}}>
                    <tbody>
                    <tr>
                        <th style={{width:170}}>Podnikové číslo</th>
                        <td>{this.state.data.eid}</td>
                    </tr>
                    <tr>
                        <th>Výrobce</th>
                        <td>{this.state.data.make}</td>
                    </tr>
                    <tr>
                        <th>Typové označení</th>
                        <td>{this.state.data.model}</td>
                    </tr>
                    <tr>
                        <th>Rok výroby</th>
                        <td>{this.state.data.year}</td>
                    </tr>
                    <tr>
                        <th>Číslo motoru</th>
                        <td>{this.state.data.engine}</td>
                    </tr>
                    <tr>
                        <th>Výrobní číslo</th>
                        <td>{this.state.data.serial}</td>
                    </tr>
                    <tr>
                        <th>Výrobní číslo sloupu</th>
                        <td>{this.state.data.column_serial}</td>
                    </tr>
                    <tr>
                        <th>Dodatkové číslo sloupu</th>
                        <td>{this.state.data.column_extra}</td>
                    </tr>
                    </tbody>
                </table>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Vehicle/Infobox.js